import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import "../..//stiluri/Contact.css";
import ButonIstoric from "../../ButonIstoric";
import SalvareDate from "../../SalvareDate";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const db = getFirestore();

  // Starea locală modificabilă
  const [localBeneficiar, setLocalBeneficiar] = useState({
    contact: { telefon: "", email: "" },
    contactApartinatori: {
      relatie: "",
      nume: "",
      prenume: "",
      telefon: "",
      email: "",
      adresa: "",
    },
  });

  const campuriSalvate = ["telefon", "email"];

  // Încarcă datele când id-ul se schimbă
  useEffect(() => {
    const fetchBeneficiar = async () => {
      if (!id) return;
      try {
        const docRef = doc(db, "Beneficiari", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();

          const contact = data.contact || { telefon: "", email: "" };
          const contactApartinatori = data.contactApartinatori || {
            relatie: "",
            nume: "",
            prenume: "",
            telefon: "",
            email: "",
            adresa: "",
          };

          setLocalBeneficiar({ contact, contactApartinatori });
        }
      } catch (error) {
        console.error("Eroare la încărcarea beneficiarului:", error);
      }
    };

    fetchBeneficiar();
  }, [id, db]);

  // Funcția pentru update localBeneficiar la schimbarea inputurilor
  const handleInputChange = (section, field) => (e) => {
    const value = e.target.value;
    setLocalBeneficiar((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  return (
    <div className="detalii-grid">
<h2>{t("contact")}</h2>

<h4>{t("personalContactDetails")}</h4>
      <label>
          <strong>{t("phone")}:</strong>
      </label>
      <input
        type="text"
        value={localBeneficiar.contact?.telefon || ""}
        onChange={handleInputChange("contact", "telefon")}
      />
      <label>
         <strong>{t("email")}:</strong>
      </label>
      <input
        type="email"
        value={localBeneficiar.contact?.email || ""}
        onChange={handleInputChange("contact", "email")}
      />

      {/* Poți adăuga și secțiunea contactApartinatori aici similar */}

      <SalvareDate
        beneficiar={localBeneficiar.contact}
        id={id}
        numeComponenta={"contact"}
        campuriSalvate={campuriSalvate}
      />

      <ButonIstoric id={id} numeComponenta={"contact"} />
    </div>
  );
};

export default Contact;
  